module.exports = __webpack_public_path__ + "img/blog5.b56d7167.png";